import type { WidgetCoreDefinition, TeXMLContext, TeXMLElement, ValidationResult } from './types';

export type StartConfig = {
  enableCallerIdMatch?: boolean;
  enableZeroPressed?: boolean;
  businessHoursId?: string;
  enableRecording?: boolean;
};

function generateTeXML(_config: StartConfig, _context: TeXMLContext): TeXMLElement[] {
  return [];
}

function validateConfig(_config: StartConfig): ValidationResult {
  return { valid: true, errors: [] };
}

export const startWidgetCore: WidgetCoreDefinition<StartConfig> = {
  id: 'start',
  version: 1,
  name: 'Start',
  description: 'Entry point for the call flow',
  category: 'control',
  tier: 'system',

  defaultConfig: {
    enableCallerIdMatch: false,
    enableZeroPressed: false,
  },

  variables: {
    outputs: [
      {
        name: 'customerId',
        description: 'Customer ID from CRM caller ID lookup',
        type: 'string',
        availableOnHandleTypes: ['success'],
      },
    ],
  },

  texml: {
    generate: generateTeXML,
    requiresCallback: false,
  },

  validation: {
    validateConfig,
  },
};
